// ZohoChat.js
import  { useEffect } from 'react';

const ZohoChat = () => {
  useEffect(() => {
    const script1 = document.createElement('script');
    script1.innerHTML = `
        window.$zoho = window.$zoho || {};
        $zoho.salesiq = $zoho.salesiq || { ready: function() {} };
    `;
    script1.type = 'text/javascript';

    const script2 = document.createElement('script');
    script2.src = 'https://salesiq.zohopublic.com/widget?wc=siqae5a32a09506e82c2b22b197c1e3da9c0eecc61794b6d9aea96d96663822d349';
    script2.defer = true;
    script2.async = true;
    script2.id = 'zsiqscript';

    document.body.appendChild(script1);
    document.body.appendChild(script2);

    return () => {
        document.body.removeChild(script1);
        document.body.removeChild(script2);
    };
}, []);

  return null;
};

export default ZohoChat;
// // ZohoChat.js
// import  { useEffect } from 'react';

// const ZohoChat = () => {
//   useEffect(() => {
//     // Dynamically add the Zoho chat script to the document body
//     const script = document.createElement('script');
//     script.src = 'https://salesiq.zoho.com/widget';
//     script.id = 'zsiqscript';
//     script.type = 'text/javascript';
//     script.defer = true;
//     document.body.appendChild(script);

//     // Add the Zoho script configuration after loading the script
//     const configScript = document.createElement('script');
//     configScript.innerHTML = `
//       var $zoho = $zoho || {};
//       $zoho.salesiq = $zoho.salesiq || {
//         widgetcode: "025b70002cebd83f0e72f6ca7b568e2e9dbdb1f3f3b82b46845acfb885e02600",
//         values: {},
//         ready: function() {}
//       };
//     `;
//     document.body.appendChild(configScript);

//     return () => {
//       // Cleanup the scripts when the component is unmounted
//       const scriptElement = document.getElementById('zsiqscript');
//       const configScriptElement = document.querySelector('script[innerHTML*="widgetcode"]');
//       if (scriptElement) {
//         document.body.removeChild(scriptElement);
//       }
//       if (configScriptElement) {
//         document.body.removeChild(configScriptElement);
//       }
//     };
//   }, []);

//   return null;
// };

// export default ZohoChat;
